import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import Form from '../../components/Form/Form';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from '../../services/data.service';
import Unauthorized from './../Authentication/Unauthorized';
import FunctionalRoles_popup_CreateFunctionalRole from './Popups/FunctionalRoles_popup_CreateFunctionalRole';

const FunctionalRolesView: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleException, handleResult } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate()

    useEffect(() => {
        getTableData()
    }, [])

    function getTableData() {
        setShowSpinner(true);
        DataService
            .get<any[]>(`api/v1/FunctionalRoles/`)
            .then(response => {
                setShowSpinner(false);
                setData(response);
            })
            .catch(e => {
                setShowSpinner(false);
                handleException(e)
            });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/FunctionalRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function hidePopup(functionalRoleId?: number) {
        setShowPopup(false)
        if (functionalRoleId) {
            getTableData()
            navigate('/plm/userManagement/functionalrole/' + functionalRoleId)
        }
    }

    const colInfos: IColInfo[] = [
        { title: 'Id', key: true, dataProp: 'id', dataType: 'number', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },
    ];
    if (isAuthorizedFor(ApplicationFunctions.UpdateApplicationRole)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    if (!isAuthorizedFor(ApplicationFunctions.ViewApplicationRole)) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title="Workflow roles" >
                    <ActionMenu title="Actions">
                        <ActionMenuItem width={300} icon="fa fa-plus" iconVariant="success" title={"Create new Role"} onClick={() => { setShowPopup(true); }} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <DataTable
                        name='dtFunctionalRoles'
                        colInfos={colInfos}
                        tableData={data}
                        navigateTitle='Workflow role'
                        navigateUrl='/plm/UserManagement/FunctionalRole/'
                    />
                </Form.Content>
            </Form>
            {showPopup && (<FunctionalRoles_popup_CreateFunctionalRole show={showPopup} onHide={hidePopup} />)}
            {showSpinner && (<SpinnerOverlay />)}
        </div>
    );
}
export default FunctionalRolesView;
